import React from "react";
import { LoginContext } from "./contextProvider";

function useLoginContext() {
  const context = React.useContext(LoginContext);

  return context;
}

export default useLoginContext;
